import { useCallback } from 'react'
import { useMutation } from 'urql'
import { selectFestivalMutation } from '../_lib/graphql/mutations'
import { useSnackbarPush } from '../_features/SnackbarContext/SnackbarContext'

// Das Festival wird am Benutzer gespeichert; der Cache invalidiert danach alle Queries (siehe cacheExchange)
export const useSelectFestival = () => {
  const [{ fetching }, executeSelect] = useMutation(selectFestivalMutation)
  const { pushError } = useSnackbarPush()

  const selectFestival = useCallback((id: string) => {
    // Die Saison gehört zum bisherigen Festival
    window.sessionStorage.removeItem('season')

    return executeSelect({ input: { id } }).then(result => {
      if (result.error) {
        pushError(result.error.message)
      }

      return !result.error
    })
  }, [executeSelect, pushError])

  return { selectFestival, selecting: fetching }
}
